import {Pipe, PipeTransform} from "@angular/core";
import {UserService} from "../../service/user.service";
import {GroupEnum} from "../../shared/enums/group.enum";

@Pipe({
  name: 'apresentaHub',
  standalone: true,
})
export class ApresentaHubPipe implements PipeTransform {

  transform(userService: UserService): boolean {
    const constratosComAcessoHub = [
      GroupEnum.ECO50,
    ];
    const user = userService.user;
    if (!user || !user.groups) {
      return false;
    }
    return user.groups.some(group => constratosComAcessoHub.includes(group.id ?? -1));
  }

}
